import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import clouds from './images/clouds.svg'
import calendar from './images/calendar.svg'
import party from './images/party.svg'
import ProgressDial from './components/ProgressDial'
import yellow_fire from './images/yellow_fire.svg'
import grey_fire from './images/grey_fire.svg'
import StreakNotification from './components/StreakNotification'
import StreakCount from './components/StreakCount'
import { daysUntil } from '../../helpers/date_helper'

const centerCssSnippet = `
  display: flex;
  justify-content: center;
  align-items: center;
`
const RowCss = css`
  display: flex;
  justify-content: center;
  gap: 12px;
  width: 100%;
`
const Row = ({ children }) => {
  return <div css={RowCss}>{children}</div>
}
const StreaksBodyCss = css`
  ${centerCssSnippet}
  position: relative;
  flex-direction: column;
  width: 100%;
  margin: 50px 0px;
  & > img {
    position: absolute;
    top: 8px;
    width: 400px;
    inset-inline-start: 50%;
    transform: translateX(-50%); /* Centering it */
  }
  & > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 400px;
    gap: 10px;
  }
`
const StreaksBody = ({ children }) => {
  return (
    <div aria-live="assertive" aria-atomic="true" css={StreaksBodyCss}>
      <img src={clouds} alt="" role="presentation" />
      <div>{children}</div>
    </div>
  )
}

const Streaks = ({ streakCount, endOfStreak, totalActivities, isCurrent }) => {
  const goal = 20
  const progress = (streakCount / goal) * 100
  const remaining = endOfStreak ? daysUntil(endOfStreak, true) : 0 // drop server timezone & ignore time (include partial days)
  const { t } = useTranslation()
  return (
    <StreaksBody>
      <Row>
        {isCurrent ? (
          <ProgressDial
            inactive={false}
            icon={yellow_fire}
            value={streakCount}
            progress={progress}
            units="weeks"
            max={20}
          />
        ) : (
          <ProgressDial inactive icon={grey_fire} value={streakCount} progress={progress} units="weeks" max={20} />
        )}
      </Row>
      <Row>
        {streakCount === 0 ? (
          <StreakNotification message={t('streaks.start', 'Complete an activity to start a streak!')} icon={calendar} />
        ) : (
          <>
            {isCurrent ? (
              <StreakNotification
                message={t(
                  'streaks.complete',
                  'You have a really good thing going! Come back next week to extend your streak to {count} weeks!',
                  { count: streakCount + 1 }
                )}
                icon={party}
              />
            ) : (
              <StreakNotification
                message={t(
                  'streaks.incomplete',
                  'You have {remaining} days to extend your streak to {totalPlus} weeks! Complete any activity to keep it going!',
                  { totalPlus: streakCount + 1, remaining }
                )}
                icon={calendar}
              />
            )}
          </>
        )}
      </Row>
      <Row>
        <StreakCount number={totalActivities} label={t('streaks.totalActivities', 'Total Activities')} />
      </Row>
    </StreaksBody>
  )
}

export default Streaks
